import { render, staticRenderFns } from "./TicketsScheduledSummary.vue?vue&type=template&id=10b56731&scoped=true"
import script from "./TicketsScheduledSummary.vue?vue&type=script&lang=js"
export * from "./TicketsScheduledSummary.vue?vue&type=script&lang=js"
import style0 from "./TicketsScheduledSummary.vue?vue&type=style&index=0&id=10b56731&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b56731",
  null
  
)

export default component.exports